module.exports = __webpack_public_path__ + "img/11.26518a05.jpg";